import React from 'react'
import classNames from 'classnames/bind'
import { withLocalization, Text } from 'hocs/localization'
import { getCurrencySymbol } from 'utils/user'
import * as styles from './RenewalLeaseAgreement.scss'

const cx = classNames.bind(styles)

const RenewalLeaseAgreement: React.SFC<any> = ({
  t,
  productName,
  customerShippingAddress,
  monthlyFee,
  monthlyPayment,
  contractId,
  activationFee,
  businessSignatory,
  businessSignatoryTitle,
  customerName,
  customerPhoneNumber,
  customerEmail,
  contractStartDate,
  originalContractSignDate,
  contractEndDate,
  firstPaymentDate,
  monthlyPaymentDay,
  totalMonthlyPayment,
  otherCharges,
  totalCost,
  totalTax,
}) => {
  const currency = getCurrencySymbol()

  return (
    <React.Fragment>
      <div className={styles.terms}>
        <div className={cx('text-center', styles.selectedPlan)}>
          <h2>{t('review')}</h2>
        </div>
        <div className={cx('col-md-12', styles.container768, styles.termsDescription)}>
          {t('leaseAgreementInfo', {
            originalContractSignDate,
          })}
        </div>
        <div className={styles.container1200}>
          <div className={styles.termsBlock}>
            <div className={styles.termsSection}>
              <div className={styles.section}>{t('section1')}</div>
            </div>
            <div className={styles.termsContent}>
              <div className={styles.summaryTable}>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('account')}</div>
                  <div className={styles.summaryValue}>{contractId}</div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('startDateLabel')}</div>
                  <div className={styles.summaryValue}>{contractStartDate}</div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('extension')}</div>
                  <div className={styles.summaryValue}>
                    {contractEndDate}
                    <div>{t('extensionText')}</div>
                  </div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('monthlyPayment')}</div>
                  <div className={styles.summaryValue}>{`${currency}${monthlyPayment}`}</div>
                </div>
                <div className={styles.summaryLine}>{t('termsAndConditionsText')}</div>
                <div className={styles.summaryLine}>{t('epsonNote')}</div>
              </div>
            </div>
          </div>
          <div className={styles.termsBlock}>
            <div className={styles.termsSection}>
              <div className={styles.section}>{t('section2')}</div>
            </div>
            <div className={styles.termsContent}>
              <div className={styles.summaryTable}>
                <div className={styles.summaryLine}>
                  {t('customerNote')}
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('customerNameLabel')}</div>
                    <div className={styles.summaryValue}>{businessSignatory
                    ? `${businessSignatory}, ${businessSignatoryTitle}`
                    : customerName
                  }</div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('mailingAddressLabel')}</div>
                  <div className={styles.summaryValue}>{customerShippingAddress}</div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('phoneLabel')}</div>
                  <div className={styles.summaryValue}>{customerPhoneNumber}</div>
                </div>
                <div className={styles.summaryLine}>
                  <div className={styles.summaryCondition}>{t('emailLabel')}</div>
                  <div className={styles.summaryValue}>{customerEmail}</div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.termsBlock}>
            <div className={styles.notes}>
              <p>{t('info1')}</p>
              <p>{t('info2')}</p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withLocalization('renewalLeaseAgreement')(RenewalLeaseAgreement)
